import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'narwhalia-cancel',
	templateUrl: './cancel.component.html',
	styleUrls: ['./cancel.component.scss']
})
export class CancelComponent implements OnInit {
	isConfirmed: boolean;
	constructor(private dialogRef: MatDialogRef<CancelComponent>) {
		this.isConfirmed = false;
	}

	ngOnInit() {}

	confirm() {
		this.isConfirmed = true;
		this.dialogRef.close();
	}

	close() {
		this.dialogRef.close();
	}
}
